var cartSubscription = {

    // Init callback
    init: function() {
        this.hideQuantityInput();
        this.deleteProductEvent();
        this.parseCheckout();
    },

    // Hide quantity input
    hideQuantityInput: function() {
        $('input.quantity[data-hidden="true"]').on('click change keyup keydown', function(event) {
            event.preventDefault();
            window.location.href = '/cart';
        });
    },

    // Delete product event
    deleteProductEvent: function() {
        $( '#cart_form .close.bundle, #cart_form .price_total_text.bundle, .subscription-title, .custom-subscription-image, .edit-subscription-link' ).on( 'click', function( event ) {
            event.preventDefault();

            var selector = $(this);

            $('#ajax-loader').show();

            // get product id
            var productId = $('#cart_form .close.bundle').find('a').attr('id');

            // check if id is numeric
            if(! $.isNumeric(productId ))
                return false;

            // get cart items
            var cartItems = cartSubscription.getCartItems();

            // wait for cart items
            $.when(cartItems).done(function(ItemsResponse) {

                // if response is empty
                if(ItemsResponse.length <= 0)
                    return false;

                // check if product in cart
                var product = {};
                $.each( ItemsResponse.items, function(index, value){
                    // init product
                    if(value.product_id == productId && product.vendor == 'Custom subscription')
                        product = value;
                });

                // if product is empty
                if(product.length <= 0)
                    return false;

                // set redirect
                var redirect = '/cart';
                if(selector.hasClass('subscription-title') || selector.hasClass('custom-subscription-image') || selector.hasClass('edit-subscription-link'))
                    redirect = selector.attr('href');

                // delete product
                cartSubscription.apiCall('/delete-product', 'POST', {'product-id':productId}, redirect);
            });
        });
    },

    // Get cart items
    getCartItems: function () {
        return jQuery.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(result) {
                return result;
            }
        });
    },

    // Delete product
    apiCall: function (url, method, data, redirect) {
        return jQuery.ajax({
            type: method,
            url: appUrl + url,
            data: data,
            cache: false,
            dataType: 'json',
            async: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function(result) {

                if(redirect == '/cart') {
                    localStorage.setItem("variants", JSON.stringify([]));
                }

                // reload page
                window.location.href = redirect;
            }
        });
    },


    // Update products price, subtotal
    parseCheckout: function() {
        let items = cartSubscription.getCheckoutItems();

        $.when(items).fail(function(response){

        }).done(function(response){
            if(response.length > 0) {
                cartSubscription.initDiscountForCustomers(response);
            }
            else {
                cartSubscription.initDiscountForAnonymous();
            }
        });
    },

    initDiscountForAnonymous: function() {
        let applied = localStorage.getItem("janet_discount");

        if(! applied || applied === null) return false;

        let form = $("#cart_form");
        let wrapper = $('#items-wrapper');
        let bcId = form.data('bc-id');
        let pcId = form.data('pc-id');
        let mscId = form.data('msc-id');
        let nbkId = form.data('nbk-id');
        let bc = wrapper.find('li[data-variant-id="' + bcId + '"]');
        let pc = wrapper.find('li[data-variant-id="' + pcId + '"]');
        let msc = wrapper.find('li[data-variant-id="' + mscId + '"]');
        let nbk = wrapper.find('li[data-variant-id="' + nbkId + '"]');

        if(bc.length == 0 && pc.length == 0 && msc.length == 0) return false;

        if(bc.length > 0 && pc.length > 0) {
            let bcQty = parseInt(bc.find('input[type="number"].quantity').val());
            let pcQty = parseInt(pc.find('input[type="number"].quantity').val());
            let totalItems = bcQty + pcQty;
            let itemDiscount = parseFloat((14.99 / parseFloat(totalItems)).toFixed(3));
            let bcDiscount = parseFloat((itemDiscount * bcQty).toFixed(2));
            let pcDiscount = parseFloat((itemDiscount * pcQty).toFixed(2));

            if((bcDiscount + pcDiscount) > 14.99) {
                let diff = (bcDiscount + pcDiscount) - 14.99;
                bcDiscount = bcDiscount - diff;
            }
            else if((bcDiscount + pcDiscount) < 14.99) {
                let diff = 14.99 - (bcDiscount + pcDiscount);
                bcDiscount = bcDiscount + diff;
            }

            cartSubscription.calculateProductPrice(bc, bcDiscount);
            cartSubscription.calculateProductPrice(pc, pcDiscount);
        }
        else if(bc.length > 0) {
            cartSubscription.calculateProductPrice(bc);
        }
        else if(pc.length > 0) {
            cartSubscription.calculateProductPrice(pc);
        }
        else if(msc.length > 0 && nbk.length > 0) {
            let mscQty = parseInt(msc.find('input[type="number"].quantity').val());
            let nbkQty = parseInt(nbk.find('input[type="number"].quantity').val());
            let totalItems = nbkQty + mscQty;
            let mscDiscount = 5.99;
            let nbkDiscount = 11.95;

            if((mscDiscount + nbkDiscount) > 17.94) {
                let diff = (mscDiscount + nbkDiscount) - 17.94;
                mscDiscount = parseFloat(mscDiscount - diff).toFixed(2);
            }
            else if((mscDiscount + nbkDiscount) < 17.94) {
                let diff = 17.94 - (nbkDiscount + mscDiscount);
                nbkDiscount = parseFloat(nbkDiscount + diff).toFixed(2);
            }

            cartSubscription.calculateProductPrice(msc, mscDiscount);
            cartSubscription.calculateProductPrice(nbk, nbkDiscount);
        }
        else if(msc.length > 0) {
            cartSubscription.calculateProductPrice(msc, 5.99);
        }


        cartSubscription.calculateSubtotal();
    },

    calculateProductPrice: function(product, discount = 14.99) {
        let priceWrapper = product.find('.price_total.overall');
        let priceWrapperMobile = product.find('.price-mobile');
        let price = priceWrapper.find('span.saso-cart-item-line-price').text();
        price = parseFloat(price.substring(1, price.length));
        let discountedPrice = price - discount;

        if(discountedPrice === 0) {
            discountedPrice = 'Free';
        }
        else {
            discountedPrice = '$' + discountedPrice.toFixed(2) ;
        }

        let html = '<del>$' + price + '</del><br><span class="money">' + discountedPrice + '</span>';
        priceWrapper.html(html);
        priceWrapperMobile.html(html);
    },

    calculateSubtotal: function() {
        let items = $('ul#items-wrapper li');

        if(items.length == 0) return false;

        let subtotal = 0;
        $.each(items, function(index, item) {
            let price = $(item).find('.price_total.overall span.money').text();
            if(price != 'Free') {
                subtotal += parseFloat(price.substring(1, price.length));
            }
        });

        $("#subtotal-wrapper").find('span.money.subtotal').text('$' + subtotal.toFixed(2) + 'USD');
    },

    initDiscountForCustomers: function(response) {
        let checkout = jQuery.parseHTML(response);

        let wrapper = $('#items-wrapper');
        let checkoutSubtotal = $(checkout).find('.total-line--subtotal .total-line__price span');
        let cartSubtotal = $('#subtotal-wrapper').find('span.money.subtotal');
        let table = $(checkout).find('.product-table');

        $.each($(wrapper).find('li'), function(){
            let id = $(this).data('id');
            let variantId = $(this).data('variant-id');

            let product = table.find('tr.product[data-product-id="' + id + '"][data-variant-id="' + variantId + '"]');

            if(product.length === 1) {
                $(this).find('.price_total.overall').html($(product).find('.product__price').html());
                $(this).find('.price-mobile').html($(product).find('.product__price').html());
            }

            if(product.length > 1) {

                let productTotalFromCheckout = cartSubscription.getProductPriceFromCheckout(product);
                let productTotalFromCart = parseFloat($(this).find('.price_total.overall').find('.saso-cart-item-line-price').text().substring(1));

                if(productTotalFromCheckout !== productTotalFromCart) {

                    $(this).find('.price_total.overall').html('<td class="product__price">'+
                        '<del class="order-summary__small-text">$' + productTotalFromCart + '</del><br>' +
                        '<span class="order-summary__emphasis">$' + productTotalFromCheckout + '</span>' +
                        '</td>');
                }
            }

        });

        if(cartSubtotal.length > 0) {
            cartSubtotal.text(checkoutSubtotal.text() + 'USD');
        }
    },

    getProductPriceFromCheckout: function(products) {
        let productTotal = parseFloat(0);
        $.each(products, function(index, item){
            let priceWrapper = $(item).find('.product__price');
            let price = parseFloat($(priceWrapper).find('span.order-summary__emphasis').text().substring(1));

            if(! isNaN(price)) {
                productTotal += price;
            }
        });

        return productTotal;
    },



    // Get checkout page html
    getCheckoutItems: function() {
        return jQuery.ajax({
            type: 'GET',
            url: '/checkout',
            cache: false,
            dataType: 'html'
        });
    }
};

$(function () {
    cartSubscription.init();
});
